import {ClsFormatosDocumentos} from "./peticiones/cls-pr-generico";

export class ClsManoDeObra {
  IdCatalogo: bigint;
  IdCatalogoS?: string;
  Codigo: string;
  DescripcionLarga: string;
  Descripcion: string;
  Unidad: string;
  Tipo: number;
  SalarioBaseMoneda1: number;
  SalarioBaseMoneda2: number;
  SalarioBaseMoneda3: number;
  FactorSalarioIntegradoMoneda1: number;
  FactorSalarioIntegradoMoneda2: number;
  FactorSalarioIntegradoMoneda3: number;
  FasarMoneda1: number;
  FasarMoneda2: number;
  FasarMoneda3: number;
  SalarioIntegradoMoneda1: number;
  SalarioIntegradoMoneda2: number;
  SalarioIntegradoMoneda3: number;
  SalarioRealMoneda1: number;
  SalarioRealMoneda2: number;
  SalarioRealMoneda3: number;
  ViaticosMoneda1: number;
  ViaticosMoneda2: number;
  ViaticosMoneda3: number;
  AlimentacionYHospedajeMoneda1: number;
  AlimentacionYHospedajeMoneda2: number;
  AlimentacionYHospedajeMoneda3: number;
  GastosDeSepelioMoneda1: number;
  GastosDeSepelioMoneda2: number;
  GastosDeSepelioMoneda3: number;
  OtrasPrestacionesMoneda1: number;
  OtrasPrestacionesMoneda2: number;
  OtrasPrestacionesMoneda3: number;
  CostoTotalMoneda1: number;
  CostoTotalMoneda2: number;
  CostoTotalMoneda3: number;
  RiesgosDeTrabajoMoneda1: number;
  RiesgosDeTrabajoMoneda2: number;
  RiesgosDeTrabajoMoneda3: number;
  TipoFasarMoneda1: number;
  TipoFasarMoneda2: number;
  TipoFasarMoneda3: number;
  FechaMoneda1: Date;
  FechaMoneda2: Date;
  Participa: boolean;
  EsPorcentaje: boolean;
}

export class ClsManoDeObraMoneda {
  IdCatalogo: bigint;
  IdCatalogoS?: string;
  Codigo: string;
  DescripcionLarga: string;
  Descripcion: string;
  Unidad: string;
  Tipo: number;
  SalarioBase: number;
  FactorSalarioIntegrado: number;
  Fasar: number;
  SalarioIntegrado: number;
  SalarioReal: number;
  Viaticos: number;
  AlimentacionHospedaje: number;
  GastosSepelio: number;
  OtrasPrestaciones: number;
  RiesgosDeTrabajo: number;
  CostoTotal: number;
  TipoFasar: number;
  Fecha: Date;
  Participa: boolean;
  EsPorcentaje: boolean;
}

export class ClsFactoresResultantes {
  Codigo: string;
  SalarioNominal: number;
  FactorSI: number;
  Fasar: number;
  SalarioReal: number;
}

export class ClsPorcentajesFASAR {
  mRiesgoTrabajo: number;
  mSalarioMinimo: number;
  mUMA: number;
  mLimiteGrupo1: number;
  mLimiteGrupo2: number;
  mAnoAplicacion: string;
  mOtrosCargosP: number;
  mPatronTrabajador: boolean;
  mPrestacionesEspecieT: number;
  mPrestacionesDineroT: number;
  mInvalidezVidaT: number;
  mCesantiaVejezT: number;
  mGuarderiasT: number;
  mCuotaFijaT: number;
  mExcedenteT: number;
  mNominaP: number;
  mInfonavitP: number;
  mSarP: number;
  mPrestacionesEspecieP: number;
  mPrestacionesDineroP: number;
  mInvalidezVidaP: number;
  mCesantiaVejezP: number;
  mGuarderiasP: number;
  mCuotaFijaP: number;
  mExcedenteP: number;
}

export class ClsDocumentosFASAR {
  fasarIndividualJNormal: ClsFormatosDocumentos
  fasarIndividualJExtra: ClsFormatosDocumentos
}
